import cn from "classnames";
import React, { useRef } from "react";
import BuyNewNodeButton from "./BuyNewNodeButton";
import NodeCard from "./NodeCard";
import TransferNodeButton from "./TransferNodeButton";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { FreeMode, Pagination, Mousewheel } from "swiper/modules";

import ArrowForwardSvg from "../../../components/svgComponents/ArrowForwardSvg";

const MyNodes = ({
  nodes,
  handleCardClick,
  isCardSelected,
  transferNode,
  openBuyNodeModal,
}) => {
  const swiperRef = useRef(null);

  return (
    <section
      className={cn(
        "bg-white flex relative flex-col gap-[5px] shadow-smallShadow py-6 rounded-3xl dark:bg-darkCardBg  z-50 w-full",
        {
          "justify-between lg:justify-normal": nodes.length <= 0,
        }
      )}
    >
      <div className="px-6 mb-[15px]">
        <p className="text-xs leading-[14px] text-semiBlack dark:text-semiWhite">
          Founder’s nodes info
        </p>
        <h3 className="font-semibold text-black text-xl leading-6 dark:text-white">
          My nodes
        </h3>
      </div>
      {nodes.length > 0 && (
        <Swiper
          direction="vertical"
          slidesPerView={2}
          spaceBetween={16}
          mousewheel={true}
          loop={nodes.length > 2}
          pagination={{
            clickable: true,
            dynamicBullets: true,
          }}
          modules={[FreeMode, Pagination, Mousewheel]}
          className="!flex !px-6 flex-col left-0 !mx-0 gap-4 !max-h-[400px] py-1 overflow-y-scroll hide-scrollbar"
          onSwiper={(swiper) => (swiperRef.current = swiper)}
        >
          {nodes.map(({ nodeId, rewardsEarned }) => (
            <SwiperSlide key={nodeId}>
              <NodeCard
                nodeName={nodeId}
                nodeXbr={rewardsEarned}
                handleCardClick={handleCardClick}
                isCardSelected={isCardSelected}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      )}
      <div>
        {nodes.length > 0 && (
          <div className="flex justify-center gap-4">
            <button
              className="w-[30px] h-[30px] flex items-center justify-center border border-black dark:border-[#fff] border-opacity-50 rounded-full"
              onClick={() => swiperRef.current?.slidePrev()}
            >
              <ArrowForwardSvg
                fill="#000"
                className="-rotate-90 block dark:hidden w-[15px]"
              />
              <ArrowForwardSvg
                fill="#fff"
                className="-rotate-90 hidden dark:block w-[15px]"
              />
            </button>
            <button
              className="w-[30px] h-[30px] flex items-center justify-center border border-black dark:border-[#fff] border-opacity-50 rounded-full"
              onClick={() => swiperRef.current?.slideNext()}
            >
              {" "}
              <ArrowForwardSvg
                fill="#000"
                className="rotate-90 block dark:hidden w-[15px]"
              />
              <ArrowForwardSvg
                fill="#fff"
                className="rotate-90 hidden dark:block w-[15px]"
              />
            </button>
          </div>
        )}

        <div className="flex flex-col gap-3 px-6 mt-[15px]">
          <BuyNewNodeButton openBuyNodeModal={openBuyNodeModal} />
          {nodes.length > 0 && (
            <TransferNodeButton transferNode={transferNode} />
          )}
        </div>
      </div>
    </section>
  );
};

export default MyNodes;
